import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useAnalytics } from '@Shared/useAnalytics';
import MenuLine from '@Shared/MenuLine';
import doesPartnerAllowCarvanaFinancing from '@utilities/doesPartnerAllowCarvanaFinancing';
import { selectPartner } from '../../ducks/selectors';
import {
  MenuButton,
  MenuTitle,
  MenuWrapper,
  OutsideClickWrapper,
  StyledArrowDropDown,
  StyledButton,
  StyledDropDown
} from './HowItWorks.styles';

const HowItWorks = ({ partner }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isExtendedWarrantyOffered } = partner;
  const { trackEvent, trackEventAndGo } = useAnalytics();

  const handleNavClick = (ev, name) => {
    trackEventAndGo(ev, 'clicked how it works link', {
      platform: 'desktop',
      link: name,
      partner: partner?.partnerVanityUrlName
    });
  };

  const handleOpenDropdown = () => {
    setIsOpen(true);
    trackEvent('user platform - header - expanded how it works', { platform: 'desktop' });
  };
  const shouldShowFinancingLink = doesPartnerAllowCarvanaFinancing(partner.partnerId);

  return (
    <Fragment>
      <MenuWrapper
        isDropdownExpanded={isOpen}
        onMouseEnter={handleOpenDropdown}
        onMouseLeave={() => setIsOpen(false)}
      >
        <MenuButton onTouchStart={() => setIsOpen(!isOpen)} disableHref>
          <MenuTitle isDropdownExpanded={isOpen}>How It Works</MenuTitle>
          <StyledArrowDropDown isDropdownExpanded={isOpen} />
        </MenuButton>
        <StyledDropDown isDropdownExpanded={isOpen} aria-label="How It Works">
          <StyledButton onClick={e => handleNavClick(e, 'Buying From Carvana')} href="/buying-a-car-online-how-it-works" target="_self">
            Buying From Carvana
          </StyledButton>
          <MenuLine />
          <StyledButton onClick={e => handleNavClick(e, 'Selling Or Trading In')} href="/selling-or-trades-how-it-works" target="_self">
            Selling Or Trading In
          </StyledButton>
          <MenuLine />
          {shouldShowFinancingLink && (
            <>
              <StyledButton onClick={e => handleNavClick(e, 'Finance With Carvana')} href="/learn-financing" target="_self">
                Finance With Carvana
              </StyledButton>
              <MenuLine />
              <StyledButton onClick={e => handleNavClick(e, 'Auto Loan Calculator')} href="/auto-loan-calculator" target="_self">
                Auto Loan Calculator
              </StyledButton>
            </>)
          }
          <MenuLine />
          <StyledButton onClick={e => handleNavClick(e, 'Carvana Value Tracker')} href="/value-tracker" target="_self">
            Carvana Value Tracker
          </StyledButton>
          <MenuLine />
          {isExtendedWarrantyOffered && (
            <StyledButton onClick={e => handleNavClick(e, 'Our Protection Plans')} href="/vehicle-protection-plans" target="_self">
              Our Protection Plans
            </StyledButton>
          )}
          <MenuLine />
          <StyledButton onClick={e => handleNavClick(e, 'Repairs with Carvana')} href="/repairs" target="_self">
            Repairs with Carvana
          </StyledButton>
          <MenuLine />
          <StyledButton onClick={e => handleNavClick(e, 'Certified Cars')} href="/certified-program" target="_self">
            Certified Cars
          </StyledButton>
          <MenuLine />
          <StyledButton onClick={e => handleNavClick(e, 'Carvana Insurance')} href="/insurance" target="_self">
            Carvana Insurance
          </StyledButton>
          <MenuLine />
          <StyledButton onClick={e => handleNavClick(e, 'Used EV Tax Credit')} href="/used-ev-tax-credit" target="_self">
            Used EV Tax Credit
          </StyledButton>
        </StyledDropDown>
      </MenuWrapper>
      <OutsideClickWrapper isDropdownExpanded={isOpen} onTouchStart={() => setIsOpen(false)} />
    </Fragment>
  );
};

const mapStateToProps = state => {
  return {
    partner: selectPartner(state),
  };
};

HowItWorks.propTypes = {
  partner: PropTypes.shape({
    isExtendedWarrantyOffered: PropTypes.bool.isRequired,
    partnerVanityUrlName: PropTypes.string,
  }),
};

export default connect(mapStateToProps)(HowItWorks);
